import { FlightEntity } from '@src/features/order/entities';
import { getFlightPosition } from '@src/features/order/provider/flight-provider/flight-position-cache';

export function resolveFallbackDronePosition(args: {
  fallbackDroneSerial?: string;
  fallbackPosition?: google.maps.LatLngLiteral | null;
  flightData?: FlightEntity | null;
}): google.maps.LatLngLiteral | null {
  const { fallbackDroneSerial, fallbackPosition, flightData } = args;

  if (fallbackDroneSerial) {
    const c = getFlightPosition(fallbackDroneSerial);
    if (c) {
      const lat = Number(c.latitude);
      const lng = Number(c.longitude);
      if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
    }
  }

  if (
    flightData?.latitude != null &&
    flightData?.longitude != null &&
    (!fallbackDroneSerial || flightData.serialNumber === fallbackDroneSerial)
  ) {
    const lat = Number(flightData.latitude);
    const lng = Number(flightData.longitude);
    if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
  }

  if (fallbackPosition) {
    const { lat, lng } = fallbackPosition;
    if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
  }

  return null;
}
